import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Product, TextNodeType } from '@mwe/models';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';
import { ProductIconComponent } from '../../product-icon/product-icon.component';
import { CorrelatedCompanyReferencePipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-product-card-simple',
  templateUrl: './product-card-simple.component.html',
  imports: [BasicCardComponent, ProductIconComponent, CorrelatedCompanyReferencePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardSimpleComponent {
  product = input.required<Product>();
  textNodeType = input<TextNodeType>('h6');
}
